<template>
    <div class="vip_home_div">
        <Vip></Vip>
    </div>
</template>

<script type="text/javascript">

import Vip from '@/components/vip_page/vip.vue'

import { mapState, mapActions } from 'vuex'

export default {
    components: {
        Vip,
    },
    computed: {
        ...mapState({
            user_info: state => state.user.user_info,
            login_user_info: state => state.loginState.user_info,
            courses_nav: state => state.user.courses_nav,
            user_id: state => state.user.user_id
        }),
    },
    methods: {
        ...mapActions({
            change_user_id: 'user/change_user_id',
            get_user_info: 'user/get_and_change_user_info',
            set_user_info: 'user/set_user_info'
        }),
    },
}
</script>
<style type="text/css">
</style>
